export const VIEW_TYPES = [
  "layout-builder-view",
  "layout-builder-context-menu",
  "page-builder-view",
  "page-builder-context-menu",
  "unknown",
];

export const props = Object.freeze({
  /**
   * Builder surface to render. "page-builder-view" composes the slotted grid; "layout-builder-view"
   * is the drag-and-drop editor; "layout-builder-context-menu" and "page-builder-context-menu" are
   * the editor side panels; "unknown" renders the initialization fallback.
   *
   * @type {String}
   * @storybook-control select
   */
  type: {
    type: String,
    required: true,
    validator: (value) => VIEW_TYPES.includes(value),
  },
  /**
   * Row gap forwarded to the rendered builder surface.
   *
   * @type {String}
   * @default undefined
   */
  rowgap: {
    type: String,
    default: undefined,
  },
});
